module.exports = __webpack_public_path__ + "static/media/in-app-icon.b1585294.svg";